import React from 'react';
import Card from './Card';

function FunnelItem({ item, max }) {
  const pct = Math.round((item.count / max) * 100);
  const colorMap = {
    violet: 'bg-violet-500',
    yellow: 'bg-yellow-400',
    orange: 'bg-orange-400',
    green: 'bg-green-500',
    red: 'bg-red-500'
  };

  return (
    <div className="py-3">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <span className={`w-3 h-3 rounded-full ${colorMap[item.color] || 'bg-gray-300'}`}></span>
          <div className="text-sm">{item.status}</div>
        </div>
        <div className="text-sm text-gray-500">{item.count} projetos</div>
      </div>

      <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden">
        <div className={`${colorMap[item.color] || 'bg-gray-300'} h-2 rounded-full`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default function Funnel({ items = [] }) {
  const max = Math.max(...items.map((i) => i.count), 1);
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium">Funis de negociação</h3>
        <select className="text-sm text-gray-500 border rounded px-2 py-1">
          <option>Este mês</option>
        </select>
      </div>

      <div className="space-y-3">
        {items.map((it, idx) => (
          <FunnelItem key={idx} item={it} max={max} />
        ))}
      </div>
    </Card>
  );
}
